import React, { useState } from "react";
// import "./login.css";

// import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import logo from "../../images/PPKM_Head.png";
import { useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import LoginController from "../Admin/Controller/login_controller.ts";
import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor.js";

const Login = () => {
  const key = "12345";
  const mode = "YMDHI";
  const Encryptor = new InfinityEncryptor(key, mode);

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null); // Reset error

    // Encrypt email and password
    const encryptedEmail = Encryptor.Encrypt(email);
    const encryptedPassword = Encryptor.Encrypt(password);

    // Call the authentication function
    const data = { encryptedEmail, encryptedPassword };

    LoginController.authenticateAdminLogin(data).then((response) => {
      if (response.authenticated) {
        localStorage.setItem("email", email);
        localStorage.setItem("userID", response.userID);
        // console.log(response.userID);

        navigate("/admin/dashboard");
      }
    });
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-wrapper">
          <div className="newbie-prompt-btn-row"></div>
          <div className="login-title">
            <img className="web-login-logo" src={logo} alt="Logo" />
          </div>
          <p className="title_para">PPKM CMS LOGIN</p>
          <p className="title_para2">Malaysia Shopping Malls Association</p>

          <form onSubmit={handleLogin}>
            <div className="login-input-row">
              <EmailIcon className="login-form-logo" />
              <input
                type="email"
                placeholder="Email Address"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="login-input-row">
              <LockIcon className="login-form-logo" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <IconButton
                onClick={togglePasswordVisibility}
                sx={{
                  padding: 0,
                }}
              >
                {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </IconButton>
            </div>
            <label className="remember-me">
              <input type="checkbox" />
              Remember Me
            </label>
            <div className="login-input-row2 button">
              <input type="submit" value="Login" />
            </div>
            {error && <p className="error-message">{error}</p>}
            <div className="forgot-password">
              <label>Forgot your password?</label>
            </div>
            <div className="pass forgot-password">
              <a onClick={() => navigate("/admin/forgotPassword")}>
                Forgot password
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
